import { createSelector } from 'reselect';

const navigationSelector = state => state.navigation;

export const getLeftNavigationSelector = createSelector(
  navigationSelector,
  navigation => navigation && navigation.leftNavigation
);
